import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=5b89a85e&scoped=true&"
import script from "./ReportCard.vue?vue&type=script&name=report-card&lang=js&"
export * from "./ReportCard.vue?vue&type=script&name=report-card&lang=js&"
import style0 from "./ReportCard.vue?vue&type=style&index=0&id=5b89a85e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89a85e",
  null
  
)

export default component.exports